/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React from "react"
import { Element } from "trux"

import "./TRCToggle.css"

function TRCToggle(props) {
    const className = "TRCToggle " + (props.primary ? "primary" : "")

    return (
        <Element
            trkAction={props.trkAction}
            className={className}
            onClick={props.onToggle}
        >
            <input
                type="checkbox"
                onChange={props.onToggle}
                checked={props.checked}
            />
            <label className="switch-label">
                <div className="switch-rail">
                    <div className="letterOn">On</div>
                    <div className="switch-slider"></div>
                    <div className="letterOff">Off</div>
                </div>
            </label>
        </Element>
    )
}

export default TRCToggle
